// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"95036bb85c658853","104":"81fd8bb182af9896","774":"50dba18d3206131a","975":"40794c0c8a32d08c","981":"d57106c02162160c"}[chunkId] + ".js";
};